import React, { useContext, useMemo } from 'react'
import { EsimContext } from 'providers'
import { useEsimOperationsContext } from '../../contexts/EsimOperationsContext'
import Button from './../../../components/Button'
import { details } from '../../../utils/objects'

/**
 *
 */
const UpdateSimConponent = (): JSX.Element => {
    const { fetchEsims, updatedEsim, updateEsimHandler } = useContext(EsimContext)
    const { data, setData, selectedUser, selectedPhone, selectedUserData, currentUser } = useEsimOperationsContext()

    const handleEsimUpdate = async () => {
        const payload = Object.keys(modifiedFields).reduce((acc, key) => {
            if (modifiedFields[key].hasChanged) {
                acc[key] = modifiedFields[key].value
            }
            return acc
        }, {})
        const updatedEsim = await updateEsimHandler(data.service_id, payload)
        if (updatedEsim) {
            setData(updatedEsim)
            fetchEsims(false, true)
        }
    }

    const modifiedFields = useMemo(() => {
        const isNxtUser = currentUser.user_tiered as boolean

        let first_name = data?.user?.first_name
        let last_name = data?.user?.last_name
        let email = data?.user?.email

        if (isNxtUser && data?.user?.extension?.number) {
            first_name = data.user.extension?.first_name
            last_name = data.user.extension?.last_name
            email = data.user.extension?.email
        }

        return {
            extension_id: {
                hasChanged: (selectedUser?.extension?.id || selectedUser?.voip_phone_id) !== (data?.user?.extension?.id || data?.user?.voip_phone_id),
                value: selectedUser?.extension?.id || selectedUser?.voip_phone_id
            },
            did: {
                hasChanged: selectedPhone !== data?.user?.did,
                value: selectedPhone
            },
            first_name: {
                hasChanged: selectedUserData?.first_name !== first_name,
                value: selectedUserData?.first_name
            },
            last_name: {
                hasChanged: selectedUserData?.last_name !== last_name,
                value: selectedUserData?.last_name
            },
            email: {
                hasChanged: selectedUserData?.email !== email,
                value: selectedUserData?.email
            }
        }
    }, [data, selectedUser, selectedPhone, selectedUserData])

    const textFieldsValid = useMemo(() => Object.keys(selectedUserData || {}).filter(selectedUserDataKey => /_valid/.test(selectedUserDataKey)).every(selectedUserDataKey => selectedUserData[selectedUserDataKey] !== false), [selectedUserData])
    const submitButtonDisabled = useMemo(() => Object.keys(modifiedFields).every(key => !modifiedFields[key].hasChanged), [modifiedFields])

    return <Button
        variant='contained'
        color='primary'
        size='large'
        onClick={handleEsimUpdate}
        className='update-btn'
        disabled={
            updatedEsim.isLoading ||
            !selectedPhone ||
            submitButtonDisabled ||
            !textFieldsValid
        }
        minWidth={125}
        isLoading={updatedEsim.isLoading}
        data-testid='update-sim-button'
    >{details.updateBtn}</Button>
}

export default UpdateSimConponent
